import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../../store/auth.store";
import { PartnerApi } from "../../../api/partner.api";
import ProductsCatalog from "../../Products/ProductsCatalog";
import { useLoanVendorProducts } from "../../../hook/partner/loanVendorProducts.partner.hook";
import { useLoanVendors } from "../../../hook/partner/loanVendors.partner.hook";
import { useLoanVendorProductAvailability } from "../../../hook/partner/loanVendorProductAvailability.partner.hook";
import { useLoansStore } from "../../../store/loans.store";
import number_format from "../../../utils/number_format";
import { toast } from "react-toastify";
import { useTranslation } from "../../../hooks/useTranslation";

export default function LoanAddItemAvailabilityForm({
                                                      handleClose,
  loan_id,
  product_id,
  vendor_id,
  callback,
  loan_from,
  loan_to,
}) {
  const { t } = useTranslation();
  const loanVendorProductAvailabilityMutation =
    useLoanVendorProductAvailability();
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const token = useAuthStore((state) => state.token);
  const [error, setError] = useState(null);

  const loanVendorProductAvailability = useLoansStore(
    (state) => state.loanVendorProductAvailability
  );

  const checkAvailability = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    loanVendorProductAvailabilityMutation.mutate({
      token,
      vendor_id,
      product_id,
      date_from: formData.get("date_from"),
      date_to: formData.get("date_to"),
    });
    setSelectedDateFrom(formData.get("date_from"));
    setSelectedDateTo(formData.get("date_to"));
  };

  useEffect(() => {
    if (token && loan_from && loan_to) {
      loanVendorProductAvailabilityMutation.mutate({
        token,
        vendor_id,
        product_id,
        date_from: loan_from,
        date_to: loan_to,
      });
      setSelectedDateFrom(loan_from);
      setSelectedDateTo(loan_to);
    }
  }, []);

  const addProduct = (index) => {
    if (parseInt(selectedAmount[index]) < 1) {
      alert(t("loans.selectQuantity"));
      return;
    }
    const data = {
      amount:
        selectedAmount[index] && selectedAmount[index] > 0
          ? selectedAmount[index]
          : 1,
      product_id: product_id,
      loan_from: selectedDateFrom,
      loan_to: selectedDateTo,
      stock: loanVendorProductAvailability.availabilities[index].stock,
    };
    setError(null);
    const result = PartnerApi.loanItemAdd({
      token,
      data,
      id: loan_id,
    });
    result
      .then((result) => {
        if ("error" in result) {
          setError(result.error);
          return;
        }

        if ("loan_id" in result) {
          handleClose();
          toast.success(t("loans.productAdded"));
          if (callback) {
            callback();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <form onSubmit={checkAvailability}>
        <div className="pb-1 text-center">
          <strong>{t("loans.selectDates")}</strong>
        </div>
        <div className="mb-2">
          <div className="d-flex justify-content-between">
            <div className="flex-fill pe-3">
              <input
                type="date"
                id="date_from"
                required={true}
                name="date_from"
                className="form-control form-control-sm"
                placeholder={t("common.from")}
                min={new Date().toISOString().split("T")[0]}
                defaultValue={loan_from}
              />
            </div>
            <div className="flex-fill pe-3">
              <input
                type="date"
                id="date_to"
                required={true}
                name="date_to"
                className="form-control form-control-sm"
                placeholder={t("common.to")}
                defaultValue={loan_to}
              />
            </div>
            <div>
              <button type="submit" className="btn btn-primary btn-sm">
                {t("loans.verify")}
              </button>
            </div>
          </div>
        </div>
      </form>
      {loanVendorProductAvailabilityMutation.isLoading &&
      selectedDateFrom &&
      selectedDateTo ? (
        <div className="alert alert-primary">{t("common.loading")}</div>
      ) : (
        selectedDateFrom &&
        selectedDateTo &&
        (loanVendorProductAvailability?.availabilities?.length > 0 ? (
          <>
            <div className="mb-2 text-center">
              {new Date(selectedDateFrom).toLocaleDateString()} -{" "}
              {new Date(selectedDateTo).toLocaleDateString()}
            </div>
            {error && <p className="alert alert-danger">{error}</p>}
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>{t("loans.stock")}</th>
                  <th width={50}>{t("loans.quantity")}</th>
                  <th width={50}></th>
                </tr>
              </thead>
              <tbody>
                {loanVendorProductAvailability.availabilities.map(
                  (item, index) => (
                    <tr key={index}>
                      <td>
                        {item.stock}
                        <br />
                        <small>
                          {t("loans.available")}: <strong>{item.availableAmount}</strong>
                        </small>
                      </td>
                      <td>
                        <input
                          type="number"
                          defaultValue={1}
                          className="form-control form-control-sm"
                          min="1"
                          max={item.availableAmount}
                          onChange={(e) =>
                            setSelectedAmount({
                              ...selectedAmount,
                              [index]: e.target.value,
                            })
                          }
                        />
                      </td>
                      <td>
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => {
                            addProduct(index);
                          }}
                        >
                          {t("loans.select")}
                        </button>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </>
        ) : loanVendorProductAvailabilityMutation.isSuccess ? (
          <div className="alert alert-danger">
            {t("loans.notAvailable")}
          </div>
        ) : (
          loanVendorProductAvailabilityMutation.error
        ))
      )}
    </>
  );
}
